// Icon weights
var FAL = 'fal';
var FAR = 'far';
// Light
export var FAL_TIMES = [FAL, 'times'];
export var FAL_CARET = [FAR, 'chevron-right'];
// Regular
export var FAR_TIMES = [FAR, 'times'];
export var FAR_CARET = [FAR, 'chevron-right'];
export var FAR_ANGLE_DOWN = [FAR, 'angle-down'];
export var FAR_ANGLE_UP = [FAR, 'angle-up'];
